<script lang="ts">
	import { AnimatedTitle, isRichTextField } from '$lib/helpers/animated.title';
	import { asText } from '@prismicio/client';
	import { onMount } from 'svelte';

	const { title, titleTag = 'h1', percentage = '50', className = '' } = $props();

	let animatedTitle: HTMLElement | null = $state(null);
	let titleText: string | null = $state(null);
	if (isRichTextField(title)) {
		titleText = asText(title);
	} else {
		titleText = title as string;
	}

	onMount(() => {
		if (animatedTitle) {
			new AnimatedTitle(animatedTitle, parseInt(percentage));
		}
	});
</script>

{#if titleText}
	<svelte:element this={titleTag} class="title-animated {className}" bind:this={animatedTitle}>
		{titleText}
	</svelte:element>
{/if}
